import { render, staticRenderFns } from "./MenuGroupFormFrame.vue?vue&type=template&id=3bd3354d&"
import script from "./MenuGroupFormFrame.vue?vue&type=script&lang=js&"
export * from "./MenuGroupFormFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports